/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 15:20:32
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 13:11:48
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Invoice/OtherInformation/index.tsx
 */
import { Button } from '@/src/components/Antd';
import Table from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { columns } from '../config';
import css from '../css.module.less';
import AddInformation from './AddInformation';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const OtherInformation = ({
  information,
  setShowModal,
  setModalTitle,
  setModalContent,
  addInformation: addInformationFun,
  editInformation: editInformationFun,
  deleteInformation: deleteInformationFun,
  disabled,
  disableAdd,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const addInformation = () => {
    setShowModal(true);
    setModalTitle(getI18n('storeInvoice.detail.addMoreInformation'));
    setModalContent(
      <AddInformation
        onCancel={() => setShowModal(false)}
        onAdd={addInformationFun}
      />,
    );
  };
  const deleteInformation = (record) => {
    deleteInformationFun(record);
  };
  const editInformation = (record) => {
    setShowModal(true);
    setModalTitle(getI18n('storeInvoice.detail.editInformation'));
    setModalContent(
      <AddInformation
        onCancel={() => setShowModal(false)}
        onAdd={editInformationFun}
        defaultData={record}
      />,
    );
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.invoiceFormat}
      title={getI18n('storeInvoice.detail.otherRequiredInformation')}
      subtitle={getI18n('storeInvoice.detail.otherTip')}>
      {disabled ? null : (
        <Table
          id='information'
          rowKey='uuid'
          className={css.globalTable}
          columns={columns(deleteInformation, editInformation, disableAdd, {
            getI18n,
          })}
          dataSource={information}
        />
      )}
      <Button
        className={css.addInformation}
        type='primary'
        disabled={disableAdd}
        onClick={addInformation}>
        {getI18n('storeInvoice.detail.addMoreInformation')}
      </Button>
    </SectionWrapper>
  );
};

export default OtherInformation;
